import React, { useLayoutEffect, useState, useEffect } from "react";
import numeral from "numeral";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

const ReconciliationMovementCard = props => {
  const {
    className,
    movement,
    onCardClick,
    onLinkedToClick,
    selected,
    singleReconciliation,
    selectedMovements
  } = props;

  const [isCollapsable, setIsCollapsable] = useState(false);
  const [collapse, setCollapse] = useState(true);
  const [noSelectedColor, setNoSelectedColor] = useState(false);

  useLayoutEffect(() => {
    let element = document.getElementById("dbx-reconciliation-movement-card_" + movement.id);
    if (element) {
      let classes = element.getElementsByClassName("dbx-reconciliation-movement-card-description");
      let description = classes && classes.length > 1 ? classes[1] : null;
      if (description) {
        if (description.clientHeight > 50) {
          setIsCollapsable(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (selectedMovements?.length > 0) {
      setNoSelectedColor(true);
    }
  }, [selectedMovements]);

  const renderCounterpartData = () => {
    let daOrA = movement.amount > 0 ? " da " : " a ";
    let reconciliationHintList = movement?.reconciliationHintList;
    return reconciliationHintList?.map((hint, idx) =>
      hint?.documentsReference ? (
        hint?.documentsReference.map((doc, index) => (
          <div key={`documentsReference_${index}`}>
            <b>{doc?.type === "INVOICE" ? "Fattura" : "Documento"}</b>
            {doc?.documentNumber ? " num. " : null}
            <b>{doc?.documentNumber}</b> {doc?.documentDate ? "del " : null}
            <b>
              {doc?.documentDate
                ? moment(doc?.documentDate).format("DD/MM/YYYY")
                : null}
            </b>{" "}
            {hint?.counterParty?.companyName ? daOrA : null}
            <b>
              {hint?.counterParty?.companyName
                ? hint?.counterParty?.companyName
                : null}
            </b>
          </div>
        ))
      ) : (
        <div key={`documentsReference_${idx}`}>
          {hint?.counterParty?.companyName ? daOrA : null}
          <b>
            {hint?.counterParty?.companyName
              ? hint?.counterParty?.companyName
              : null}
          </b>
        </div>
      ));
  };

  let iconMovement = selected ? "times" : movement.linked ? "link" : null;

  return (
    <div
      onClick={(e) => {
        if (!movement.linked && movement.linkable === true){
          /** Al click riporta la card in alto come "primo elemento"  */
          e.currentTarget.scrollIntoView();
          onCardClick(movement.id);
        }
      }
      }
      id={"dbx-reconciliation-movement-card_" + movement.id}
      key={"dbx-reconciliation-movement-card_" + movement.id}
      className={className || ""}
    >
      <div
        style={{cursor: !movement.linkable && "not-allowed"}}
        className={
          "dbx-reconciliation-movement-card" +
          (isCollapsable ? (collapse ? " collapse" : " collapse show") : "") +
          (selected ? " selected" : "") +
          (noSelectedColor && !selected ? " otherNoSelected" : "")
        }
      >
        <div className={"dbx-reconciliation-movement-card-row row-1"}>
          <div className={"dbx-reconciliation-movement-card-date"}>
            {moment(movement.transactionDate).format("DD MMM YY")}
          </div>
          <div
            className={
              "dbx-reconciliation-movement-card-amount" +
              (movement.amount < 0 ? " amountMinus" : " amountPlus")
            }
          >
            <FontAwesomeIcon
              style={{
                color: noSelectedColor && !selected ? "rgb(157, 166, 173)" : ""
              }}
              icon={[
                "fas",
                movement.amount < 0 ? "minus-circle" : "plus-circle"
              ]}
            />{" "}
            {numeral(Math.abs(movement.amount)).format("0,0.00") + " €"}
          </div>
        </div>
        <div className={"dbx-reconciliation-movement-card-description"}>
          {renderCounterpartData()}
        </div>
        <div className={"dbx-reconciliation-movement-card-row row-2"}>
          <div className={"dbx-reconciliation-movement-card-description"}>
            {movement.description}
          </div>
          {singleReconciliation ? (
            <div
              className="dbx-drawer-reconciliation-movement-icon"
              onClick={() =>
                (!movement.linked && movement.linkable === true) ? onCardClick(movement.id) : null
              }
            >
              {iconMovement && <FontAwesomeIcon icon={["far", iconMovement]} />}
            </div>
          ) : (
            <div>&nbsp;</div>
          )}
        </div>
        <div className={"dbx-reconciliation-movement-card-row row-3"}>
          <div
            className="dbx-reconciliation-movement-card-linkedTo"
            onClick={!movement.linkable ? null : e => {
              e.stopPropagation();
              onLinkedToClick(movement);
            }}
          >
            {movement.linked && !singleReconciliation && movement.linkable && (
              <FontAwesomeIcon icon={["far", "link"]} />
            )}
            {!singleReconciliation && !movement.linkable && (
              <FontAwesomeIcon icon={["far", "lock"]} />
            )}
          </div>
          <div className="dbx-reconciliation-movement-card-collapse">
            {isCollapsable ? (
              <FontAwesomeIcon
                onClick={e => {
                  e.stopPropagation();
                  setCollapse(!collapse);
                }}
                icon={["fal", collapse ? "chevron-down" : "chevron-up"]}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconciliationMovementCard;
